import { get, post } from "../request.js";
import { useUserInfoStore } from "../../store/modules/userInfo";
export const ApiGetLearnInfo = {
  get: () => {
    const userInfo = useUserInfoStore();
    return get(`/idx/entry?ins=${userInfo.ins}`);
  },
};

export const ApiGetHomeFunc = {
  get: () => {
    return get(`/idx/functionlist`);
  },
};

export const ApiGetHomeActivity = {
  get: () => {
    return get(`/idx/allactivity`);
  },
};

export const ApiGetPreload = {
  get: () => {
    return get(`/idx/preload
    `);
  },
};

// achievement
export const ApiGetAchievement = {
  get: () => {
    const userInfo = useUserInfoStore();
    return get(`/myachv/idx?ins=${userInfo.ins}`);
  },
};

export const ApiGetAllAvatar = {
  get: () => {
    return get(`/myachv/titlestructure`);
  },
};

// dailycheck
export const ApiGetDailyCheck = {
  get: (year, month) => {
    return get(`/sign/idx/${year}/${month}`);
  },
};

export const ApiCheckIn = {
  get: () => {
    return get(`/idx/checkin`);
  },
};
export const ApiGetNotify = {
  get: () => {
    return get(`/ores/getanncmnt`);
  },
};
